import { useTable } from "react-table";
import { useMemo, useState } from "react";

import {
  defaultDateDisplay,
  formatCurrency,
  formatNumberWithCommas,
  truncateString,
} from "../../../../../helpers";
import { useSelector } from "react-redux";
import { useGetUserList } from "../../../../../hooks/api/queries/useSettings";

const useOrderItems = ({ orderDetails, type }) => {
  const [orderItems, setOrderItems] = useState(type);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { data: userList } = useGetUserList();

  const commonColumn = useMemo(
    () => [
      {
        Header: "QUANTITY",
        accessor: "quantity",
        Cell: ({ cell: { value } }) => formatNumberWithCommas(value),
      },
    ],
    [],
  );

  const soldColumns = useMemo(
    () => [
      {
        Header: "NAME",
        accessor: "cart_item_name",
        Cell: ({ cell: { value } }) => truncateString(value, 50),
      },
      ...commonColumn,
      {
        Header: "UNIT",
        accessor: "product_unit",
        Cell: ({ cell: { value } }) => value || "N/A",
      },
      {
        Header: "ITEM AMOUNT",
        accessor: "unit_price",
        Cell: ({ cell: { value } }) =>
          value
            ? formatCurrency({
                value,
                currencyCode: orderDetails?.store?.currency_code,
              })
            : "N/A",
      },
      {
        Header: "TOTAL AMOUNT",
        accessor: "total_price",
        Cell: ({ cell: { value } }) =>
          value
            ? formatCurrency({
                value,
                currencyCode: orderDetails?.store?.currency_code,
              })
            : "N/A",
      },
    ],
    [],
  );

  const returnColumns = useMemo(
    () => [
      {
        Header: "NAME",
        accessor: "cart_item",
        Cell: ({ cell: { value } }) =>
          truncateString(value?.cart_item_name, 40),
      },
      ...commonColumn,
      {
        Header: "UNIT",
        accessor: "product_unit",
        Cell: ({ row }) => row?.original?.cart_item?.product_unit || "N/A",
      },
      {
        Header: "UNIT AMOUNT",
        accessor: "unit_price",
        Cell: ({ row }) =>
          formatCurrency({
            value: row?.original?.cart_item?.unit_price,
            currencyCode: orderDetails?.store?.currency_code,
          }),
      },
      {
        Header: "TOTAL AMOUNT",
        accessor: "total_amount",
        Cell: ({ cell: { value } }) =>
          value
            ? formatCurrency({
                value,
                currencyCode: orderDetails?.store?.currency_code,
              })
            : "N/A",
      },
      {
        Header: "STORE",
        accessor: "store",
        Cell: ({ cell: { value } }) =>
          storeList?.find((storeItem) => `${storeItem?.id}` === `${value}`)
            ?.name,
      },
      {
        Header: "INITIATOR",
        accessor: "user",
        Cell: ({ cell: { value } }) =>
          userList?.find((userId) => `${userId?.id}` === `${value}`)
            ?.first_name,
      },
      {
        Header: "DATE/TIME",
        accessor: "created_at",
        Cell: ({ cell: { value } }) => defaultDateDisplay(value),
      },
    ],
    [userList],
  );

  const instance = useTable({
    columns: orderItems === "RETURNED" ? returnColumns : soldColumns,
    data:
      orderItems === "RETURNED"
        ? orderDetails?.returned_items
        : orderDetails?.order_items || [],
  });

  return {
    instance,
    orderItems,
    setOrderItems,
  };
};

export default useOrderItems;
